import { Enums } from '@flightscope/baseball-stats';

const PitchCall = {
  ...Enums.PitchCall,
  ContactOut: { key: 'CO', name: 'Contact Out' },
  BallInPlay: { key: 'BP', name: 'Hit' },
};

export default PitchCall;
